function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWysuppLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 471.2,
    height: 82.1,
    viewBox: "0 0 471.2 82.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182,46.3h.2c.4-2.6,1-5.5,1.8-8.6l9.1-35h14.7l8.8,35.2c.6,2.5,1.2,5.6,1.8,9.1h.2c.5-3.3,1-6.4,1.6-9.1l7.2-35.2h12.7L225.4,64.1H212.2L201.8,24.3a72,72,0,0,1-1.6-7.8H200a55,55,0,0,1-1.5,7.5L188.2,64.1H174.8L160.3,2.7h12.9l7.3,35C181.1,40.4,181.6,43.2,182,46.3Z",
    style: {
      fill: "#163029"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6,51.2h.2c.8-3,1.4-5,1.7-5.9l8.6-25.6h12.2L265.2,65.4c-2.6,6.9-5.2,11.4-7.6,13.5s-6,3.2-10.5,3.2a41.5,41.5,0,0,1-8-1.1l1.9-9a16.7,16.7,0,0,0,4.2.8,8.7,8.7,0,0,0,3.5-.7,7.4,7.4,0,0,0,2.5-2.5,29.8,29.8,0,0,0,2.3-5.4l-17-44.5h12.6L257.7,45A60.9,60.9,0,0,1,259.6,51.2Z",
    style: {
      fill: "#163029"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.1,27a10,10,0,0,0-4.5,1,3.2,3.2,0,0,0-1.7,2.7,3.3,3.3,0,0,0,.8,2.2,7.6,7.6,0,0,0,2.9,1.7,34.3,34.3,0,0,0,5.8,1.3c5.6,1,9.8,2.6,12.5,4.8s4,5.4,4,9.5a13.9,13.9,0,0,1-2.3,7.7,14.4,14.4,0,0,1-6.5,5.3,23.5,23.5,0,0,1-10,1.9c-5.8,0-10.4-1.1-13.7-3.5a14.3,14.3,0,0,1-6.1-10.2l11-1.7a10,10,0,0,0,2.8,5.3,9.5,9.5,0,0,0,6,1.7,10.3,10.3,0,0,0,5.4-1.2,4.1,4.1,0,0,0,2-3.5,3.1,3.1,0,0,0-.7-2.1,5.2,5.2,0,0,0-2.4-1.5,41.5,41.5,0,0,0-5.2-1.2c-6.2-.9-10.6-2.7-13.4-5.2a12.7,12.7,0,0,1-4.2-10,12.1,12.1,0,0,1,2.1-7.1,13.5,13.5,0,0,1,6.2-4.6,24.3,24.3,0,0,1,9.4-1.6c5.2,0,9.4,1,12.6,3.1a12.6,12.6,0,0,1,5.8,8.8l-11.2,1.6a6.3,6.3,0,0,0-2.5-3.8A8.4,8.4,0,0,0,302.1,27Z",
    style: {
      fill: "#163029"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.8,56.1a9.4,9.4,0,0,0,4.3-1,8.7,8.7,0,0,0,3.5-3.6,16,16,0,0,0,1.4-7.1V19.7h11.7V64.1H356.8V58.3a16.9,16.9,0,0,1-5.9,5.1,17.6,17.6,0,0,1-7.6,1.7c-5,0-8.7-1.3-11.3-3.9s-3.9-6.3-3.9-11V19.7h11.8V47.4c0,3,.5,5.2,1.7,6.6S344.4,56.1,346.8,56.1Z",
    style: {
      fill: "#163029"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.2,59.3H389V81.1H377.2V19.7h11v6.5h.2a13.7,13.7,0,0,1,6-5.7,17.2,17.2,0,0,1,7.8-1.8,16,16,0,0,1,9.6,2.9,19.3,19.3,0,0,1,6.7,8.3,29.8,29.8,0,0,1,2.4,12.4,28.5,28.5,0,0,1-2.4,12.2,17.1,17.1,0,0,1-16.4,10.6,18.7,18.7,0,0,1-7.2-1.2A16.5,16.5,0,0,1,389.2,59.3Zm10.2-31.2a9.3,9.3,0,0,0-7.6,3.5c-1.9,2.3-2.9,6.1-2.9,11.3a18.5,18.5,0,0,0,1.2,6.9,10.4,10.4,0,0,0,3.5,4.4,8.8,8.8,0,0,0,5.3,1.6,8.4,8.4,0,0,0,7.4-3.6c1.7-2.4,2.6-5.9,2.6-10.4s-.9-7.7-2.6-10.1A8,8,0,0,0,399.4,28.1Z",
    style: {
      fill: "#163029"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.5,59.3h-.2V81.1H427.5V19.7h11v6.5h.2a13.7,13.7,0,0,1,6-5.7,17.2,17.2,0,0,1,7.8-1.8,16,16,0,0,1,9.6,2.9,18.6,18.6,0,0,1,6.7,8.3,29.8,29.8,0,0,1,2.4,12.4,28.5,28.5,0,0,1-2.4,12.2,17.3,17.3,0,0,1-6.6,7.9,17.8,17.8,0,0,1-9.8,2.7,18.7,18.7,0,0,1-7.2-1.2A16.5,16.5,0,0,1,439.5,59.3Zm10.2-31.2a9,9,0,0,0-7.5,3.5c-2,2.3-3,6.1-3,11.3a18.5,18.5,0,0,0,1.2,6.9,10.4,10.4,0,0,0,3.5,4.4,8.9,8.9,0,0,0,5.4,1.6,8.2,8.2,0,0,0,7.3-3.6c1.7-2.4,2.6-5.9,2.6-10.4s-.9-7.7-2.6-10.1A7.9,7.9,0,0,0,449.7,28.1Z",
    style: {
      fill: "#163029"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.9,49.8H33.6a16.2,16.2,0,0,1,0-32.4h8.3A33.4,33.4,0,0,1,71.3,0H33.6a33.6,33.6,0,1,0,0,67.1H71.3A33.5,33.5,0,0,1,41.9,49.8Z",
    style: {
      fill: "#163029",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5,33.6A16.3,16.3,0,0,1,71.3,49.8h29.3a33.3,33.3,0,0,0,0-32.4H71.3A16.2,16.2,0,0,1,87.5,33.6Z",
    style: {
      fill: "#163029",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,33.6A16.2,16.2,0,0,1,71.3,17.4H41.9a33.3,33.3,0,0,0,0,32.4H71.3A16.3,16.3,0,0,1,55,33.6Z",
    style: {
      fill: "#163029",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9,0H71.3a33.4,33.4,0,0,1,29.3,17.4h8.3a16.2,16.2,0,0,1,0,32.4h-8.3A33.5,33.5,0,0,1,71.3,67.1h37.6a33.6,33.6,0,1,0,0-67.1Z",
    style: {
      fill: "#163029",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6,49.8H41.9a33.5,33.5,0,0,0,58.7,0Z",
    style: {
      fill: "#163029"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9,17.4h58.7a33.5,33.5,0,0,0-58.7,0Z",
    style: {
      fill: "#163029"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWysuppLogo);
export default __webpack_public_path__ + "static/media/wysupp-logo.0a655f3030feb6fa98dc6eed06bc2267.svg";
export { ForwardRef as ReactComponent };